import type BABYLON from 'babylonjs';

import type { Globals } from './globals';

// cf. https://doc.babylonjs.com/typedoc/classes/babylon.engine

export type EngineCallback = (engine: BABYLON.Engine) => unknown;

export type EngineCanvasOrContext = NonNullable<ConstructorParameters<typeof BABYLON.Engine>[0]>;

export interface EngineOptions extends BABYLON.EngineOptions {
  onResize?: EngineCallback | null;
  onCreate?: EngineCallback;
}

export function createEngine(
  globals: Globals,
  canvasOrContext: EngineCanvasOrContext,
  {
    onResize = (engine): void => {
      engine.resize();
    },
    onCreate,
    antialias = true,
    ...options
  }: EngineOptions = {}
): BABYLON.Engine {
  const engine = new globals.BABYLON.Engine(canvasOrContext, antialias, { antialias, ...options });

  if (onResize) {
    const onResizeWindow = (): void => {
      onResize(engine);
    };
    window.addEventListener('resize', onResizeWindow);
    engine.onDisposeObservable.addOnce(() => {
      window.removeEventListener('resize', onResizeWindow);
    });
    onResizeWindow();
  }

  onCreate?.(engine);

  return engine;
}
